if(document.readyState !== 'loading') {
  addCrossSellItemsToCartFn();
  document.addEventListener('cart:rinit', function() {
      reloadCrossSectionPart();
  });
} else {
  document.addEventListener('DOMContentLoaded', function () {
    addCrossSellItemsToCartFn();
    document.addEventListener('cart:rinit', function() {
        reloadCrossSectionPart();
    });
  });
}
// window.addEventListener("load", function() {
//     addCrossSellItemsToCartFn();
//     document.addEventListener('cart:rinit', function() {
//         reloadCrossSectionPart();
//     });
// });

document.addEventListener('drawerOpen', function(){
  let cartDrawerDiv = document.querySelector("#CartDrawer");

  if(cartDrawerDiv.classList.contains("drawer--is-open"))
    runFlickiySlider();
});

function reloadCrossSectionPart(){
    document.querySelector("#cross_section_footer").classList.add("hideCross");
    document.querySelector("#cross_section_footer").classList.remove("showCross");

    fetch("/?sections=cross-sell-section")
    .then((response) => response.json())
    .then((response) => {
        document.getElementById('cross_section_footer').innerHTML = new DOMParser().parseFromString(response['cross-sell-section'], 'text/html').getElementById('shopify-section-cross-sell-section').innerHTML;
        runFlickiySlider();
        document.querySelector("#cross_section_footer").classList.remove("hideCross");
        document.querySelector("#cross_section_footer").classList.add("showCross");
        addCrossSellItemsToCartFn();
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      console.log('request done successfully');
    });
}

function runFlickiySlider () {
    let slider = document.querySelector('#testimonials-custom-cross-section .cross-sell-slider'),
        crossSEllWrapper = document.querySelector('#testimonials-custom-cross-section .cross-sell-wrapper');
    if(slider){
        let flickConfig = JSON.parse(slider.getAttribute('data-flickity-config'));
        if((slider.dataset.count > 3)
        || (window.innerWidth <= 768 && slider.dataset.count >= 3)){
          if(crossSEllWrapper && crossSEllWrapper.classList.contains('flex-control'))
            crossSEllWrapper.classList.remove('flex-control');
          let flkty = new Flickity('#testimonials-custom-cross-section .cross-sell-slider', flickConfig);
          flkty.resize();
        }else{
          if(crossSEllWrapper && !crossSEllWrapper.classList.contains('flex-control'))
            crossSEllWrapper.classList.add('flex-control');
        }
    }
}

function addCrossSellItemsToCartFn(){
    let add_x_sell_cart_items = document.querySelectorAll(".add_x_sell_cart .quickCartImage"),
        x_sell_items_length = add_x_sell_cart_items.length;

    for( var i = 0; i < x_sell_items_length; i++){
        add_x_sell_cart_items[i].addEventListener('click', function(){
        let btnVariantId = this.getAttribute("data-variant-id");
        addToCartCrossSell(btnVariantId);
        });
    }
}

function addToCartCrossSell(variant_id){
    let formData = {
      "items":[
        {
          "id": variant_id,
          "quantity": 1
        }
      ]
    };

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(product => {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: ''
          }
      }));
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}